import { logger } from 'shared/logging';


export const logErrors = (error: Error, customMessage: string) => {
  const statusCode = error.response?.status;
  const errorMessage = error.message;
  if (statusCode) {
    logger.error(`${statusCode}: ${customMessage}`);
  } else {
    logger.error(error, errorMessage);
  }
};
